<nz-form-item class="wrapper-form-item">
  <ng-container
    *ngIf="to['extraTemplate']"
    [ngTemplateOutlet]="to['extraTemplate']"
  ></ng-container>
  <nz-form-label [nzRequired]="to.required">
    {{ to.label }}
  </nz-form-label>
  <nz-form-control [nzErrorTip]="errorTpl" [nzValidateStatus]="errorState">
    <textarea
      [rows]="to.rows"
      nz-input
      [formControl]="formControl"
      style="resize: none"
    ></textarea>
    <ng-template #errorTpl let-control>
      <formly-validation-message [field]="field"></formly-validation-message>
    </ng-template>
  </nz-form-control>
</nz-form-item>
